<template>
  <el-dialog title="Thông báo" :visible.sync="localVisible" width="560px" :append-to-body="false">
    <div>Bạn đã phân loại được lỗi cho tác vụ này chưa?</div>

    <div class="mt-4">
      <el-radio-group v-model="localOption" @change="$emit('change')">
        <div>
          <el-radio label="continue">Chưa phân loại được lỗi, tiếp tục tìm bài thanh tra.</el-radio>
        </div>
        <div class="mt-2">
          <el-radio label="classify">Đã phân loại được, thực hiện phân loại.</el-radio>
        </div>
      </el-radio-group>
    </div>

    <div v-if="localOption === 'classify'" class="mt-3">
      <el-select v-model="localClassificationType" placeholder="Chọn phân loại" clearable filterable style="width: 100%;">
        <el-option label="Lỗi sự vụ" value="incident" />
        <el-option label="Lỗi hệ thống" value="system" />
      </el-select>
    </div>

    <div v-if="decisionError" style="color:#f1416c" class="mt-3">{{ decisionError }}</div>
    <div v-if="classificationError" style="color:#f1416c" class="mt-2">{{ classificationError }}</div>
    <span slot="footer" class="dialog-footer">
      <button class="btn btn-light-gray font-weight-bold mr-2" @click="onCancel">
        <i class="fas fa-times"></i> Hủy
      </button>
      <button class="btn btn-purple font-weight-bold mr-2" @click="onConfirm">
        <i v-if="loading" class="fas fa-spinner fa-spin"></i>
        <i v-else class="fas fa-check"></i>
        {{ loading ? 'Đang xác nhận...' : 'Xác nhận' }}
      </button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'SupplementDecisionDialog',
  props: {
    visible: { type: Boolean, default: false },
    option: { type: String, default: '' },
    classificationType: { type: String, default: '' },
    decisionError: { type: String, default: '' },
    classificationError: { type: String, default: '' },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      localOption: this.option,
      localClassificationType: this.classificationType,
    }
  },
  watch: {
    option(v) { this.localOption = v; },
    classificationType(v) { this.localClassificationType = v; },
    localOption(v) { this.$emit('update:option', v); },
    localClassificationType(v) { this.$emit('update:classificationType', v); },
  },
  computed: {
    localVisible: {
      get() { return this.visible; },
      set(v) { this.$emit('update:visible', v); }
    }
  },
  methods: {
    onCancel() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
    },
    onConfirm() {
      this.$emit('confirm');
    }
  }
}
</script>

<style scoped>
</style>


